import { useCallback, useEffect } from "react";
import { isLessonIncompleteAI } from "@src/features/contentDetail/utils/courses";
import { cloneDeep } from "lodash";
import {
  CourseContentCourseVersionFragment,
  CourseContentLessonFragment,
} from "../build/CourseBuildContent.generated";
import { useAtomCallback } from "jotai/utils";
import { courseVersionAtom } from "../atoms";

type Args = {
  initialOrPollingCourseVersion:
    | CourseContentCourseVersionFragment
    | undefined
    | null;
};

const useUpdateAILessons = ({ initialOrPollingCourseVersion }: Args): void => {
  const updateAILessons = useAtomCallback(
    useCallback(
      (get, set) => {
        const courseVersion = get(courseVersionAtom);
        if (!courseVersion || !initialOrPollingCourseVersion) return;
        if (
          !courseVersion?.lessons.some(
            (lesson) => isLessonIncompleteAI(lesson),
            false,
          )
        ) {
          return;
        }
        const lessons = courseVersion.lessons.map<CourseContentLessonFragment>(
          (lesson) => {
            if (isLessonIncompleteAI(lesson)) {
              const newLesson = initialOrPollingCourseVersion?.lessons.find(
                (l) => l.uuid === lesson.uuid,
              );
              return newLesson ? newLesson : lesson;
            }
            return lesson;
          },
        );
        set(courseVersionAtom, {
          ...courseVersion,
          lessons: cloneDeep(lessons),
        });
      },
      [initialOrPollingCourseVersion],
    ),
  );
  useEffect(() => {
    updateAILessons();
  }, [updateAILessons]);
};

export default useUpdateAILessons;
